import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import StepSidebar from '../Components/stepSidebar/stepSidebar';
import styles from './conteudo.scss';
import Aprendizagem from './etapas/aprendizagem';
import ArticulacaoMobilizacao from './etapas/articulacaoMobilizacao';
import Curriculo from './etapas/curriculo';
import ExpedicaoInvestigativa from './etapas/expedicaoInvestigativa';
import IndiceFinal from './etapas/indiceFinal';
import Indices from './etapas/indices';
import InfosIniciais from './etapas/infosIniciais';
import RevisaoFinalizacao from './etapas/revisaoFinalizacao';
import Titulo from './etapas/titulo';
const { rootClassName } = styles;

const etapas = {
  [EtapaProjeto.infosIniciais]: <InfosIniciais />,
  [EtapaProjeto.curriculo]: <Curriculo />,
  [EtapaProjeto.expedicao]: <ExpedicaoInvestigativa />,
  [EtapaProjeto.tituloDoProjeto]: <Titulo />,
  [EtapaProjeto.indices]: <Indices />,
  [EtapaProjeto.mobilizacao]: <ArticulacaoMobilizacao />,
  [EtapaProjeto.aprendizagem]: <Aprendizagem />,
  [EtapaProjeto.indiceFinal]: <IndiceFinal />,
  [EtapaProjeto.revisao]: <RevisaoFinalizacao />,
};

export default function Conteudo() {
  const { state } = useContext(ProjetosContext);

  const { stepSlugName } = useParams<{
    stepSlugName: string;
  }>();

  return (
    <div className={rootClassName}>
      <StepSidebar />
      <div key={String(etapas[state.etapa])} className={`${rootClassName}-mid`}>
        {Object.values(EtapaProjeto).map((etapa) => {
          return (
            <CSSTransition
              in={stepSlugName === etapa}
              key={etapa}
              timeout={300}
              classNames='etapa-animation'
              unmountOnExit
              mountOnEnter
              enter
              appear
            >
              {etapas[etapa]}
            </CSSTransition>
          );
        })}
      </div>
    </div>
  );
}
